export default "__VITE_ASSET__CC2D024B__"